import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class NegotiationModel extends BaseModel {
  bidder_uuid = null;
  amount = null;
  comment = null;

  rules = {
    bidder_uuid: 'required',
    amount: 'required|min_value:0.1',
  };

  attributeLabels = {
    bidder_uuid: i18n.t("Winning Bidder"),
    amount: i18n.t("Winning Price"),
    comment: i18n.t("Comment")
  };

  attributeHints = {};

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
